window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';
      if (centsAmount === ",00" || centsAmount === ".00") {
        centsAmount = '';
      }

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ",");
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Utilities ================*/
/**
* Responsive Script
* ------------------------------------------------------------------------------
* A file that contains scripts highly couple code to the Responsive utility.
*
* @namespace Responsive
*/

theme.Responsive = (function() {
  function Responsive() {

    _classCallCheck(this, Responsive);

    this.currentBreakpoint = Responsive.getCurrentBreakpoint();

    window.addEventListener('resize', function() {
      var newBreakpoint = Responsive.getCurrentBreakpoint();

      if (this.currentBreakpoint === newBreakpoint) {
        return;
      }

      document.dispatchEvent(new CustomEvent('breakpoint:changed', {
        detail: {
          previousBreakpoint: this.currentBreakpoint,
          currentBreakpoint: newBreakpoint
        }
      }));

      this.currentBreakpoint = newBreakpoint;
    });
  };

  Responsive.prototype.matchesBreakpoint = function(breakpoint) {
    switch (breakpoint) {
      case 'small':
        return window.matchMedia('screen and (max-width: 640px)').matches;

      case 'medium':
        return window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches;

      case 'medium-up':
        return window.matchMedia('screen and (min-width: 641px)').matches;

      case 'medium-down':
        return window.matchMedia('screen and (max-width: 1007px)').matches;

      case 'large':
        return window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches;

      case 'large-up':
        return window.matchMedia('screen and (min-width: 1008px)').matches;

      case 'desktop':
        return window.matchMedia('screen and (min-width: 1280px)').matches;

      case 'widescreen':
        return window.matchMedia('screen and (min-width: 1600px)').matches;
    }
  };

  Responsive.prototype.getCurrentBreakpoint = function() {
    if (window.matchMedia('screen and (max-width: 640px)').matches) {
      return 'small';
    }

    if (window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches) {
      return 'medium';
    }

    if (window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches) {
      return 'large';
    }

    if (window.matchMedia('screen and (min-width: 1280px)').matches) {
      return 'desktop';
    }
  };

  return Responsive;
})();

/**
* Carousels Script
* ------------------------------------------------------------------------------
* A file that contains scripts highly couple code to the Carousel utility.
*
* @namespace Carousels
*/

theme.Carousels = (function() {
  function Carousels(element) {

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Carousels);

    this.element = element;
    this.initialConfig = $(element).data('flickity-config');
    this.options = options;

    this._attachListeners();
    this._build();

  };

  Carousels.prototype.destroy = function() {
    this.flickityInstance.destroy();

    if (this.initialConfig['breakpoints'] !== undefined) {
      document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
    }
  };

  Carousels.prototype.selectCell = function(index) {
    var shouldPause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var shouldAnimate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    if (shouldPause) {
      this.flickityInstance.pausePlayer();
    }

    this.flickityInstance.select(index, false, !shouldAnimate);
  };

  Carousels.prototype.pausePlayer = function() {
    this.flickityInstance.pausePlayer();
  };

  Carousels.prototype.unpausePlayer = function() {
    this.flickityInstance.unpausePlayer();
  };

  Carousels.prototype.resize = function() {
    this.flickityInstance.resize();
  };

  Carousels.prototype.getSelectedIndex = function() {
    return this.flickityInstance.selectedIndex;
  };

  Carousels.prototype.getSelectedCell = function() {
    return this.flickityInstance.selectedCell.element;
  };

  Carousels.prototype._attachListeners = function() {
    if (this.initialConfig['breakpoints'] !== undefined) {
      this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
      document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
    }
  };

  /**
  * Create the carousel instance
  */

  Carousels.prototype._build = function() {
    var _this = this;

    var config = this._processConfig();

    this.flickityInstance = new Flickity(this.element, config);
    this._validateDraggable();

    this.selectedIndex = this.flickityInstance.selectedIndex;

    this.flickityInstance.on('resize', this._validateDraggable.bind(this));

    if (this.options['onSelect']) {
      this.flickityInstance.on('select', function() {
        // Flickity will send the "select" event whenever the window resize (even on mobile...), as a consequence we need to check
        // first if the slide index have changed or not (cf: https://github.com/metafizzy/flickity/issues/529)

        if (_this.selectedIndex !== _this.flickityInstance.selectedIndex) {
          _this.options['onSelect'](_this.flickityInstance.selectedIndex, _this.flickityInstance.selectedCell.element);
          _this.selectedIndex = _this.flickityInstance.selectedIndex;
        }
      });
    }

    if (this.options['onClick']) {
      this.flickityInstance.on('staticClick', function(event, pointer, cell, index) {
        _this.options['onClick'](cell, index);
      });
    }
  };

  /**
  * By default, Flickity does not disable draggable automatically if there is nothing to slide. We therefore manually do the check here by checking
  * if the displayed elements equals to the amount of elements
  */

  Carousels.prototype._validateDraggable = function() {
    var isActive = this.flickityInstance.isActive || false;

    if (!isActive || !this.flickityInstance.options['draggable']) {
      return; // Not draggable, so nothing to do
    }

    if (undefined === this.flickityInstance.selectedElements || this.flickityInstance.selectedElements.length === this.flickityInstance.cells.length) {
      this.flickityInstance.unbindDrag();
    } else {
      this.flickityInstance.bindDrag();
    }
  };

  /**
  * Flickity is a CSS driven library and hence it is hard to setup some stuff in pure JS
  */

  Carousels.prototype._processConfig = function() {
    var config = Object.assign({}, this.initialConfig);

    delete config['breakpoints'];

    if (this.initialConfig['breakpoints'] === undefined) {
      return config; // No change, we simply return the config as it is
    }

    var breakpoints = this.initialConfig['breakpoints'];

    breakpoints.forEach(function(breakpoint) {
      if (theme.Responsive.matchesBreakpoint(breakpoint['matches'])) {
        config = Object.assign(config, breakpoint['settings']);
      }
    });

    return config;
  };

  /**
  * Verify if the breakpoint has changed, and optionally update the carousel
  */

  Carousels.prototype._onBreakpointChanged = function() {
    // The breakpoint may have changed, so we delete the carousel and rebuild it
    this.flickityInstance.destroy();
    this._build();
  };

  return Carousels;

})();

/**
 * Modals Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Modals utility.
 *
   * @namespace Modals
 */

theme.Modals = (function() {
  function Modal(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active',
      closingClass: 'modal--is-closing',
      bodyOpenClass: 'modal-open',
      bodyOpenSolidClass: 'modal-open--solid',
      bodyClosingClass: 'modal-closing',
      closeOffContentClick: true
    };

    this.id = id;
    this.$modal = $('#' + id);

    if (!this.$modal.length) {
      return false;
    }

    this.nodes = {
      $parent: $('html').add('body'),
      $modalContent: this.$modal.find('.modal__inner')
    };

    this.config = $.extend(defaults, options);
    this.modalIsOpen = false;
    this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
    this.isSolid = this.config.solid;

    this.init();
  }

  Modal.prototype.init = function() {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');

    $(this.config.open).on('click', this.open.bind(this));
    this.$modal.find(this.config.close).on('click', this.close.bind(this));

    // Close modal if a drawer is opened
    $('body').on('drawerOpen', function() {
      this.close();
    }.bind(this));
  };

  Modal.prototype.open = function(evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.modalIsOpen && !externalCall) {
      this.close();
    }

    this.$modal
      .prepareTransition()
      .addClass(this.config.openClass);
    this.nodes.$parent.addClass(this.config.bodyOpenClass);

    if (this.isSolid) {
      this.nodes.$parent.addClass(this.config.bodyOpenSolidClass);
    }

    this.modalIsOpen = true;


    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    $('body').trigger('modalOpen.' + this.id);

    this.bindEvents();
  };

  Modal.prototype.close = function() {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$modal
      .prepareTransition()
      .removeClass(this.config.openClass)
      .addClass(this.config.closingClass);
    this.nodes.$parent.removeClass(this.config.bodyOpenClass);
    this.nodes.$parent.addClass(this.config.bodyClosingClass);
    var o = this;
    window.setTimeout(function() {
      o.nodes.$parent.removeClass(o.config.bodyClosingClass);
      o.$modal.removeClass(o.config.closingClass);
    }, 500); // modal close css transition

    if (this.isSolid) {
      this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass);
    }

    this.modalIsOpen = false;


    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false').focus();
    }

    $('body').trigger('modalClose.' + this.id);

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function() {
    // Pressing escape closes modal
    this.nodes.$parent.on('keyup.modal', function(evt) {
      if (evt.keyCode === 27) {
        this.close();
      }
    }.bind(this));

    if (this.config.closeOffContentClick) {
      // Clicking outside of the modal content also closes it
      this.$modal.on('click.modal', this.close.bind(this));

      // Exception to above: clicking anywhere on the modal content will NOT close it
      this.nodes.$modalContent.on('click.modal', function(evt) {
        evt.stopImmediatePropagation();
      });
    }
  };

  Modal.prototype.unbindEvents = function() {
    this.nodes.$parent.off('.modal');

    if (this.config.closeOffContentClick) {
      this.$modal.off('.modal');
      this.nodes.$modalContent.off('.modal');
    }
  };

  return Modal;
})();


/*================ Sections ================*/

/**
 * Variant Collection
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly coupled code to the Wear-it-with module.
 *
 * @namespace WearItWith
 */

theme.WearItWith = (function() {

  function WearItWith(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');

    if (!$container.length) {
      return;
    }

    this.data = {
      carouselElement: $($container).find('.wear-it-with__carousel')[0]
    };

    if (this.data.carouselElement != undefined) {
      this.carousel = new theme.Carousels(this.data.carouselElement);
    }

  }

  WearItWith.prototype = $.extend({}, WearItWith.prototype, {
    onUnload: function() {
      this.$container.off(this.settings.eventNamespace);
    }
  });

  return WearItWith;

})();

/**
 * Cookie Banner Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cookie Banner module.
 *
   * @namespace CookieBanner
 */

theme.CookieBanner = (function() {

  function CookieBanner(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    this.cookieName = $container.data('cookie-name');

    if (!$container.length) {
      return;
    }

    this.elements = {
      declineButton: $container.find('#cookieDecline'),
      cookieFunctions: $container.find('#cookieFunctions'),
      cookieBannerInner: $container.find('#cookieBannerInner'),
      readMoreButton: $container.find('#cookieReadMore')
    }

    this.data = {
      secondsBeforeShow: $container.data('delay-seconds'),
      daysBeforeReappear: $container.data('delay-days'),
      cookie: $.cookie(this.cookieName),
      testMode: $container.data('test-mode'),
      mode: $container.data('mode')
    };

    this.modal = new theme.Modals('CookieBanner-' + sectionId, 'cookiebanner-popup-modal', {
      bodyOpenClass: 'modal-open--scrollable'
    });

    this.elements.declineButton.on('click', (event) => {
      this.handleCookieDecline();
    });

    this.elements.readMoreButton.on('click', (event) => {
      this.elements.cookieBannerInner.toggleClass('expanded');
      this.elements.cookieFunctions.toggleClass('open');
    });

    console.info('%c[Cookie Banner] ' + '%cCookie: ' + this.data.cookie, 'color: blue;', 'color: black;');

    $('body').on('modalClose.' + $container.attr('id'), this.closePopup.bind(this));

    // Open the modal
    if (this.data.mode == 'enabled' || this.data.testMode) {
      if (_.isUndefined(this.data.cookie) || this.data.testMode) {
        this.initPopupDelay();
      }
    }

    window.CookieBanner = this;

  }

  CookieBanner.prototype = $.extend({}, CookieBanner.prototype, {

    initPopupDelay: function() {

      setTimeout(function() {
        this.openPopup();
      }.bind(this), this.data.secondsBeforeShow * 1000);

    },

    openPopup: function() {
      this.modal.nodes.$modalContent = this.$container.find('.cookie-banner-bar');
      this.modal.open();
    },

    openPopup: function() {
      this.modal.nodes.$modalContent = this.$container.find('.cookie-banner-bar');
      this.modal.open();
    },

    handleCookieDecline: function() {
      this.closePopup();
      if (confirm("Du kan ikke bruge vores website uden cookies. Er du sikker?")) {
        this.elements.cookieBannerInner.addClass('expanded');
        this.elements.cookieFunctions.addClass('open');
        this.elements.declineButton.prop('disabled', true);
      } else {
        this.openPopup();
      }
    },

    closePopup: function() {
      // Remove a cookie in case it was set in test mode

      this.elements.cookieBannerInner.removeClass('expanded');
      this.elements.cookieFunctions.removeClass('open');
      this.elements.declineButton.prop('disabled', false);

      if (this.data.testMode) {
        $.removeCookie(this.cookieName, { path: '/' });
        return;
      }

      this.setCookie();
    },

    setCookie: function() {
      $.cookie(this.cookieName, true, { path: '/', expires: this.data.daysBeforeReappear });
    },

    onLoad: function() {
      this.openPopup();
    },

    onSelect: function() {
      this.openPopup();
    },

    onDeselect: function() {
      this.modal.close();
    },

    onBlockSelect: function(event) {
      if (!this.modal.modalIsOpen) {
        this.openPopup();
      }
      $(event.target).show();
    },

    onBlockDeselect: function(event) {
      $(event.target).hide();
    },

    onUnload: function() { }
  });

  return CookieBanner;
})();

/**
 * TEMP
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Store Locator.
 *
 * @namespace StoreLocator
 */

theme.StoreLocator = function(options) {

  /*************** Variables ***************/

  var config = {
    "filterOnlineEl": $('#filter-online'),
    "filterPhysicalEl": $('#filter-physical'),
    "filterTextEl": $('#filterInput'),
    "filterWrapEl": $('.stores__filter-wrap'),
    "filterAddressEl": $('#addressInput'),
    "filterRadiusEl": $('#filterRadius'),
    "filterLocationEl": $('#filterLocation'),
    "filterNoResultsEl": $('#filterNoResults'),
    "filterInvalidAddressEl": $('#filterInvalidAddress'),
    "storeEls": $('.store-item'),
    "resultCountEl": $('.stores__result-count'),
    "resultCountSingle": $('.stores__result-count').data('single'),
    "resultCountPlural": $('.stores__result-count').data('plural'),
    "storeGridClass": '.store-grid',
    "storeCountryClass": '.stores__country',
    "brandStoresClass": '.stores__brand-stores',
    "brandStoreClass": '.brand-store',
    "sectionByCountry": options.sectionByCountry,
    "mapId": "storesMap",
    "mapWrapClass": ".stores__map"
  };

  var allLocations = [];

  // If map or location based search is enabled, it's important that we only use
  // locations that has coordinates.
  if (options.inputType == 'blocks') {
    if (options.enableMap) {
      allLocations = _.remove(options.storeJSON, function(n) {
        return !(isNaN(n.lat) || isNaN(n.lng));
      });
    } else {
      allLocations = options.storeJSON;
    }

    textFilter();
  } else {
    if (options.csvPath != '') {

      Papa.parse(options.csvPath, {
        download: true,
        quoteChar: '"',
        delimiter: ";",
        skipemptylines: true,
        header: true,
        complete: function(results, file) {

          var mappedJSON = _.map(results.data, function(obj) {

            var mappedObj = {
              "title": obj[options.csvFieldCompany],
              "addressStreet": obj[options.csvFieldAddress],
              "addressPostalCode": obj[options.csvFieldPostalCode],
              "addressLocality": obj[options.csvFieldCity],
              "addressRegion": obj[options.csvFieldRegion],
              "addressCountry": obj[options.csvFieldCountry],
              "addressString": createNiceAddress(obj),
              "phone": obj[options.csvFieldPhone],
              "email": obj[options.csvFieldEmail],
              "lat": parseFloat(obj[options.csvFieldLatitude]),
              "lng": parseFloat(obj[options.csvFieldLongitude]),
              "url": obj[options.csvFieldWebsite],
              "niceUrl": createNiceURL(obj[options.csvFieldWebsite]),
              "_search": obj[options.csvFieldCompany].toLowerCase() + ' ' + createNiceAddress(obj).toLowerCase()
            }

            return mappedObj;

          });

          var filteredJSON = _.filter(mappedJSON, function(obj) {
            return !_.isUndefined(obj.addressCountry);
          });

          allLocations = filteredJSON;

          if (options.enableAutoFilterLocation) {
            $(config.filterLocationEl).click();
          } else {
            textFilter(filteredJSON);
          }

        }
      });
    }
  }


  /**
  * Inititate slider for brand stores
  **/
  if ($(config.brandStoreClass).length > 1) {
    $(config.brandStoresClass).slick({
      adaptiveHeight: true,
      arrows: false,
      dots: true
    });
  }

  /**
  * Filters an array of locations based on text input
  **/
  function textFilter(data) {

    $(config.storeGridClass).empty();
    $(config.storeCountryClass).hide();

    function filter(items, text) {
      return find(items, text);
    }

    function find(items, text) {
      text = text || '';
      text = text.toLowerCase().split(' ');
      return items.filter(function(item) {
        return text.every(function(el) {
          return item._search.indexOf(el) > -1;
        });
      });
    }

    var filterText = config.filterTextEl.val();

    var items = data || allLocations;

    var filteredArray = filter(items, filterText);

    $(config.storeGridClass).toggleClass('filtered', filteredArray.length != items.length);

    createListOfLocations(filteredArray);

    if (options.enableMap) {
      createSearchableMap(filteredArray.length ? filteredArray : items);
    }

  }


  /**
  * Creates a nice address string based on fields
  *
  * @param {Object}
  *
  **/
  function createNiceAddress(obj) {
    var str = [];

    if (!_.isUndefined(obj)) {

      if (obj[options.csvFieldAddress]) {
        str.push(obj[options.csvFieldAddress])
      }

      if (obj[options.csvFieldPostalCode]) {
        str.push(obj[options.csvFieldPostalCode])
      }

      if (obj[options.csvFieldCity]) {
        str.push(obj[options.csvFieldCity])
      }

      if (obj[options.csvFieldRegion]) {
        str.push(obj[options.csvFieldRegion])
      }

      return str.join(' ');

    } else {
      return '';
    }
  }

  /**
  * Creates a nice web address string based on URL
  *
  * @param {String}
  *
  **/
  function createNiceURL(url) {
    var str = '';

    if (!_.isUndefined(url)) {

      var str = url.replace(/http:\/\//g, '').replace(/https:\/\//g, '');

      return str;

    } else {
      return '';
    }
  }

  /**
  * Creates a nice web address string based on URL
  *
  * @param {Object}
  *
  **/
  function createStoreCard(store) {
    var template = options.storeTemplate;
    Mustache.parse(template);   // optional, speeds up future uses
    var rendered = Mustache.to_html(template, store);

    return rendered;
  }

  /**
  * Creates a map based on array of locations
  *
  * @param {Array} locations (optional)
  *
  **/
  function createSearchableMap(locations = allLocations) {

    var map;
    var bounds = new google.maps.LatLngBounds();
    var mapOptions = { mapTypeId: 'roadmap' };
    var markers = [];
    var infoWindowContent = [];

    if (options.mapStylesJSON) {
      mapOptions.styles = options.mapStylesJSON;
    }

    if (!options.enableUI) {
      mapOptions.disableDefaultUI = true;
    }

    var map = new google.maps.Map(document.getElementById(config.mapId), mapOptions);
    map.setTilt(45);

    locations.forEach(function(location) {
      if (location.lat != '' && location.lat != '') {
        markers.push([location.title, location.lat, location.lng]);

        infoWindowContent.push(['<div class="infoWindow"><h3>' + location.title +
          '</h3><p>' + location.addressString + '</p></div>']);
      }

    });

    var infoWindow = new google.maps.InfoWindow(), marker, i;

    // Place the markers on the map
    for (i = 0; i < markers.length; i++) {
      var position = new google.maps.LatLng(markers[i][1], markers[i][2]);
      bounds.extend(position);
      marker = new google.maps.Marker({
        position: position,
        map: map,
        title: markers[i][0],
        icon: options.mapMarkerImage
      });

      // Add an infoWindow to each marker, and create a closure so that the current
      // marker is always associated with the correct click event listener
      google.maps.event.addListener(marker, 'click', (function(marker, i) {
        return function() {
          infoWindow.setContent(infoWindowContent[i][0]);
          infoWindow.open(map, marker);
        }
      })(marker, i));

      // Only use the bounds to zoom the map if there is more than 1 location shown
      if (locations.length > 1) {
        map.fitBounds(bounds);
      } else {
        var center = new google.maps.LatLng(locations[0].lat, locations[0].lng);
        map.setCenter(center);
        map.setZoom(15);
      }
    }
  }

  /**
  * Filters array of locations based on distance from coordinates.
  * By default coordinates are looked up based on address input.
  *
  * @param {String} lat The latitude (optional)
  * @param {String} lng The longitude (optional)
  *
  **/
  function geoFilter(lat, lng) {
    var userLatLng;
    var geocoder = new google.maps.Geocoder();
    var userAddress = $(config.filterAddressEl).val().replace(/[^a-z0-9\s]/gi, '');
    var maxRadius = parseInt($(config.filterRadiusEl).val(), 10);

    if (userAddress == '' && typeof lat == 'undefined' && typeof lng == 'undefined') {

      if (options.enableMap) {
        createSearchableMap(allLocations);
      }

      createListOfLocations(allLocations);
      return;
    }

    if (typeof lat !== 'undefined' && typeof lng !== 'undefined' && maxRadius) {

      handleLatLngFilter(lat, lng);

    } else if (userAddress && maxRadius) {

      userLatLng = getLatLngViaHttpRequest(userAddress);

      function getLatLngViaHttpRequest(address) {
        // Set up a request to the Geocoding API
        // Supported address format is City, City + State, just a street address, or any combo
        var addressStripped = address.split(' ').join('+');
        var key = options.gmapsAPI;
        var request = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + addressStripped + '&key=' + key;

        // Call the Geocoding API using jQuery GET, passing in the request and a callback function
        // which takes one argument "data" containing the response
        $.get(request, function(data) {

          // Abort if there is no response for the address data
          if (data.status === "ZERO_RESULTS") {
            $(config.filterInvalidAddressEl).show();
            return;
          }

          $(config.filterInvalidAddressEl).hide();

          handleLatLngFilter(data.results[0].geometry.location.lat, data.results[0].geometry.location.lng);

        });
      }
    }

    /**
    * Filters array of locations based on distance from coordinates.
    *
    * @param {String} lat The latitude (optional)
    * @param {String} lng The longitude (optional)
    *
    **/
    function handleLatLngFilter(lat, lng) {
      var userLatLng = new google.maps.LatLng(lat, lng);
      var filteredLocations = allLocations.filter(isWithinRadius);

      if (filteredLocations.length > 0) {
        $(config.filterNoResultsEl).hide();

        if (options.enableMap) {
          createSearchableMap(filteredLocations);
        }

        createListOfLocations(filteredLocations);
      } else {
        $(config.filterNoResultsEl).show();
      }

      function isWithinRadius(location) {
        var locationLatLng = new google.maps.LatLng(location.lat, location.lng);
        var distanceBetween = google.maps.geometry.spherical.computeDistanceBetween(locationLatLng, userLatLng);

        return convertMetersToKilometers(distanceBetween) <= maxRadius;
      }
    }
  }

  function convertMetersToKilometers(meters) {
    return (meters * 0.001);
  }


  // Create/update list of stores based on array
  function createListOfLocations(locations) {

    $(config.storeGridClass).empty();
    $(config.storeCountryClass).hide();

    if (locations.length == 1) {
      var resultsCountText = config.resultCountSingle;
    } else {
      var resultsCountText = config.resultCountPlural;
    }

    $(config.resultCountEl).text(locations.length + ' ' + resultsCountText);

    if (config.sectionByCountry) {

      // sort by country
      locations.sort(function(a, b) {

        var o1 = a.addressCountry.toLowerCase();
        var o2 = b.addressCountry.toLowerCase();

        var p1 = a.title.toLowerCase();
        var p2 = b.title.toLowerCase();

        if (o1 < o2) return -1;
        if (o1 > o2) return 1;
        if (p1 < p2) return -1;
        if (p1 > p2) return 1;
        return 0;
      });

    } else {
      // sort by name
      locations.sort(function(a, b) {
        var nameA = a.title.toUpperCase(); // ignore upper and lowercase
        var nameB = b.title.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
    }

    // Set current country
    var countryCode = '';

    for (var i = 0; i < locations.length; i++) {

      var store = locations[i];

      countryCode = store.addressCountry;

      var storeCardTemplate = createStoreCard(store);

      if (!config.sectionByCountry) {
        $(config.storeGridClass).append(storeCardTemplate);
      } else if (countryCode != '') {
        $('[data-country=' + countryCode + ']').show();
        $('[data-country=' + countryCode + '] ' + config.storeGridClass).append(storeCardTemplate);
      }

      countryCode = store.addressCountry;
    }

  }

  function handleLocationError(browserHasGeolocation, infoWindow, pos) {
    infoWindow.setPosition(pos);
    infoWindow.setContent(browserHasGeolocation ?
      'Error: The Geolocation service failed.' :
      'Error: Your browser doesn\'t support geolocation.');
    infoWindow.open(map);
  }


  // Click event listener on filter submit
  $('#filterSearch').on('click', function(e) {

    if (options.enableMap || options.enableFilterLocation) {
      $(config.filterLocationEl).data('lat', undefined);
      $(config.filterLocationEl).data('lng', undefined);
      $(config.filterLocationEl).attr('data-location', false);

      e.preventDefault();
      geoFilter();
    } else {

      e.preventDefault();
      textFilter()
    }
  });

  // Change event listener on radius select
  $(config.filterRadiusEl).on('change', function(e) {
    if ($(config.filterLocationEl).data('lat') != '') {
      geoFilter($(config.filterLocationEl).data('lat'), $(config.filterLocationEl).data('lng'));
    } else {
      geoFilter();
    }
  });


  // Click event listener on filter location
  $(config.filterLocationEl).on('click', function(e) {
    e.preventDefault();

    if ($(e.target).attr('data-location') == 'true') {
      $(e.target).attr('data-location', false);
      $(config.filterLocationEl).data('lat', '');
      $(config.filterLocationEl).data('lng', '');
      geoFilter();
      return;
    }

    $(config.filterAddressEl).prop('disabled', true);
    $(config.filterWrapEl).addClass('loading_location');

    // Try HTML5 geolocation.
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function(position) {

        $(config.filterAddressEl).val(null);

        geoFilter(position.coords.latitude, position.coords.longitude);

        $(e.target).data('lat', position.coords.latitude)
        $(e.target).data('lng', position.coords.longitude)
        $(config.filterAddressEl).prop('disabled', false);
        $(e.target).attr('data-location', true);
        $(config.filterWrapEl).removeClass('loading_location');

      }, function() {
        $(config.filterAddressEl).prop('disabled', false);
        $(e.target).attr('data-location', false);
        $(config.filterWrapEl).removeClass('loading_location');
        handleLocationError(true, infoWindow, map.getCenter());
      });
    } else {
      // Browser doesn't support Geolocation
      handleLocationError(false, infoWindow, map.getCenter());
    }
  });


  // Change event listener on text filter
  $(config.filterTextEl).on('change', function(e) {
    textFilter()
  });

  // $(config.filterOnlineEl).add(config.filterPhysicalEl).change(function() {
  //   textFilter();
  // });

};

/**
 * Variant Collection
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly coupled code to the Variants Collection module.
 *
 * @namespace ImageSlider
 */

theme.ImageSlider = (function() {

  function ImageSlider(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');

    if (!$container.length) {
      return;
    }

    this.data = {
      carouselElement: $($container).find('.LifestyleGallery__Carousel')[0],
      nextElement: $($container).find('.CarouselNav__Next'),
      prevElement: $($container).find('.CarouselNav__Prev')
    };

    if (this.data.carouselElement != undefined) {
      this.carousel = new theme.Carousels(this.data.carouselElement);
    }

    setTimeout((function() {
      this.carousel.resize();
    }).bind(this), 800);

    setTimeout((function() {
      this.carousel.resize();
    }).bind(this), 3000);


  }

  ImageSlider.prototype = $.extend({}, ImageSlider.prototype, {
    onUnload: function() {
      this.carousel.flickityInstance.destroy();
      this.$container.off(this.settings.eventNamespace);
    },
    onBlockSelect: function(event) {
      this.carousel.flickityInstance.selectCell(event.target.getAttribute('data-slide-index'), false, !event.detail.load);
    }
  });

  return ImageSlider;

})();


/*================ Templates ================*/
/**
 * CART
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart.
 *
 * @namespace cart
 */

theme.cart = function() {

  /*************** Variables ***************/

  var config = {
    'agreementCheckbox': '#cartAgreementCheckbox'
  };

  // Check that the agreement checkbox is clicked
  $('body').on('click', '[name=checkout]', function(ev) {

    if ($(config.agreementCheckbox).is(':checked')) {
      $(this).submit();
    }
    else {
      $('.PageOverlay').addClass('is-visible');
      $('#agreementBox').addClass('open');
      return false;
    }
  });

};


$(document).ready(function() {

  // General scripts
  var sections = new slate.Sections();
  //sections.register('cookie-banner', theme.CookieBanner);
  sections.register('image-slider', theme.ImageSlider);

  // Product gallery swiping fix

  var tapArea, startX;
  tapArea = document.querySelectorAll('.Product__Slideshow');
  startX = 0;
  for (var item of tapArea) {
    item.ontouchstart = function(e) {
      startX = e.touches[0].clientX;
    };
    item.ontouchmove = function(e) {
      if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable) {
        e.preventDefault();
      }
    };
  }

  // Megamenu

  $('[data-action="toggle-side-mega-menu"]').click(function(e) {
    $('#sideMegaMenuSec').attr('aria-hidden', false);
    $('.SidebarMegaMenu__SubMenu').attr('aria-hidden', true);
    $('#' + $(this).data('controls-sub')).attr('aria-hidden', false);
    $('#' + $(this).data('controls-sub') + ' .SidebarMegaMenu__imageWrapper').attr('aria-hidden', true);
    $('#' + $(this).data('controls-sub') + ' #image-' + $(this).data('controls')).attr('aria-hidden', false);
  })

  $('[data-action="menu-preview"]').hover(function() {
    $('#' + $(this).data('controls-sub') + ' .SidebarMegaMenu__imageWrapper').attr('aria-hidden', true);
    $('#' + $(this).data('controls-sub') + ' #image-' + $(this).data('controls')).attr('aria-hidden', false);
  })

  $('.SidebarMegaMenu__imageWrapper').each(function(i) {
    $('#' + this.id).not(this).remove();
  });

  // Upselling on add_to_cart

  $('.closeModal').click(function() {
    $('#sidebar-cart').attr('aria-hidden', true);
    $('#sidebar-cart').css('display', 'none');
  });

  function addToCart(variant_id, addToCartButton = null) {
    if (addToCartButton) {
      addToCartButton.setAttribute('disabled', 'disabled');
      addToCartButton.innerHTML = `<span>${ window.languages.productAdding } <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 20"><path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1.167 1.6666h1.0885c.205 0 .3075 0 .39.0377a.4167.4167 0 0 1 .1774.154c.049.0763.0635.1778.0925.3807L3.3098 5m0 0 .8766 6.4428c.1113.8176.1669 1.2264.3623 1.5341.1723.2712.4192.4868.711.6209.3313.1522.744.1522 1.569.1522h7.1316c.7855 0 1.1782 0 1.4992-.1414a1.6671 1.6671 0 0 0 .7011-.5801c.1988-.2889.2723-.6747.4193-1.4462l1.103-5.791c.0517-.2715.0776-.4073.0401-.5134a.4164.4164 0 0 0-.1831-.2213C17.4427 5 17.3045 5 17.028 5H3.3099Zm4.5239 12.5a.8333.8333 0 0 1-1.6667 0 .8334.8334 0 1 1 1.6667 0Zm6.6666 0a.8333.8333 0 1 1-.8333-.8334.8333.8333 0 0 1 .8333.8334Z"></path></svg></span>`
    }

    fetch(window.routes.cartAddUrl + '.js', {
      body: JSON.stringify({ id: variant_id, quantity: 1 }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(function(response) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      if (response.ok) {
        if (addToCartButton) {
          addToCartButton.removeAttribute('disabled');
          addToCartButton.innerHTML = `<span>${ window.languages.productAdded } <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 20"><path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1.167 1.6666h1.0885c.205 0 .3075 0 .39.0377a.4167.4167 0 0 1 .1774.154c.049.0763.0635.1778.0925.3807L3.3098 5m0 0 .8766 6.4428c.1113.8176.1669 1.2264.3623 1.5341.1723.2712.4192.4868.711.6209.3313.1522.744.1522 1.569.1522h7.1316c.7855 0 1.1782 0 1.4992-.1414a1.6671 1.6671 0 0 0 .7011-.5801c.1988-.2889.2723-.6747.4193-1.4462l1.103-5.791c.0517-.2715.0776-.4073.0401-.5134a.4164.4164 0 0 0-.1831-.2213C17.4427 5 17.3045 5 17.028 5H3.3099Zm4.5239 12.5a.8333.8333 0 0 1-1.6667 0 .8334.8334 0 1 1 1.6667 0Zm6.6666 0a.8333.8333 0 1 1-.8333-.8334.8333.8333 0 0 1 .8333.8334Z"></path></svg></span>`

          setTimeout(function() {
            addToCartButton.innerHTML = `<span>${ window.languages.productAddShort } <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 20"><path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1.167 1.6666h1.0885c.205 0 .3075 0 .39.0377a.4167.4167 0 0 1 .1774.154c.049.0763.0635.1778.0925.3807L3.3098 5m0 0 .8766 6.4428c.1113.8176.1669 1.2264.3623 1.5341.1723.2712.4192.4868.711.6209.3313.1522.744.1522 1.569.1522h7.1316c.7855 0 1.1782 0 1.4992-.1414a1.6671 1.6671 0 0 0 .7011-.5801c.1988-.2889.2723-.6747.4193-1.4462l1.103-5.791c.0517-.2715.0776-.4073.0401-.5134a.4164.4164 0 0 0-.1831-.2213C17.4427 5 17.3045 5 17.028 5H3.3099Zm4.5239 12.5a.8333.8333 0 0 1-1.6667 0 .8334.8334 0 1 1 1.6667 0Zm6.6666 0a.8333.8333 0 1 1-.8333-.8334.8333.8333 0 0 1 .8333.8334Z"></path></svg></span>`
          }, 1500);
        }
        // We simply trigger an event so the mini-cart can re-render
        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: variant_id,
            quantity: 1
          }
        }));
      } else {
        response.json().then(function(content) {
          var errorMessageElement = document.createElement('span');
          errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
          errorMessageElement.innerHTML = content['description'];

          if (addToCartButton) {
            addToCartButton.removeAttribute('disabled');
            addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
            setTimeout(function() {
              errorMessageElement.remove();
            }, 2500);
          }
        });
      }
    });
  };

  var productRecom = document.querySelector('.gr-product__recom');

  if (productRecom) {
    var atcs = productRecom.querySelectorAll('.gr-btn');

    atcs.forEach(function(btn) {
      btn.addEventListener('click', function() {
        addToCart(btn.dataset.id, btn);
      })
    })
  }

  // Custom input
  $('.ProductForm__AddToCart').click(function(e) {
    if ($(this).hasClass("disabled")) {
      e.preventDefault();
      $('.CustomLength__Input').addClass('border_Red');
      $('.CustomLength__Errors').addClass('CustomLength__FadeIn');
    }
  });

  $('.CustomLength__Input').change(function(e) {
    var inputContentLength = $('.CustomLength__Input').val();
    if (inputContentLength === '' || inputContentLength === null || inputContentLength === 0) {
      $('.ProductForm__AddToCart').prop('disabled', true).removeAttr('data-action');

      $('.CustomLength__Input').addClass('border_Red');
      $('.ProductForm__AddToCart').addClass('disabled');
    } else {
      $('.ProductForm__AddToCart').prop('disabled', false).attr('data-action', 'add-to-cart');
      $('.CustomLength__Input').removeClass('border_Red');
      $('.ProductForm__AddToCart').removeClass('disabled');
      $('.CustomLength__Errors').removeClass('CustomLength__FadeIn');
    }
    handleCustomLength();
  });

  const input = document.querySelector('.CustomLength__Input');
  if (input) {
    input.addEventListener('input', function() {
      this.value = this.value.replace('.', ',');
      this.value = this.value.replace(/[^0-9\,]/, '');
    });
  }

  $('.CustomLength__Input').keyup(function(e) {
    var inputContentLength = $('.CustomLength__Input').val();
    if (inputContentLength === '' || inputContentLength === null || inputContentLength === 0) {
      $('.ProductForm__AddToCart').prop('disabled', true).removeAttr('data-action');

      $('.CustomLength__Input').addClass('border_Red');
      $('.ProductForm__AddToCart').addClass('disabled');
    } else {
      $('.ProductForm__AddToCart').prop('disabled', false).attr('data-action', 'add-to-cart');
      $('.CustomLength__Input').removeClass('border_Red');
      $('.ProductForm__AddToCart').removeClass('disabled');
      $('.CustomLength__Errors').removeClass('CustomLength__FadeIn');
    }
    handleCustomLength();
  });

  function handleCustomLength() {
    var value_raw = Math.floor($('.CustomLength__Input').val().replace(',', '.'));
    var value = value_raw.toFixed(1);
    if ($('.CustomLength__Input')[0].value.indexOf('.') != -1 && $('.CustomLength__Input')[0].value.split('.')[1].length > 1) {
      $('.CustomLength__Input')[0].value = $('.CustomLength__Input')[0].value.substring(0, $('.CustomLength__Input')[0].value.length - 1);
    }
    var toSelect = $('.SizeSwatch__Radio').filter(function() {
      return $(this).data('minimum') <= value && $(this).data('maximum') >= value;
    });
    if (!toSelect.length) {
      $('.CustomLength__Input').val($('.CustomLength__Input').attr('max'));
      $('.SizeSwatch__Radio').last().click();
    } else {
      toSelect.click();
    }
  }


  //Readmore functionality on product and collection pages
  $('.readmore').click(function(event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.product-description-full');
    descriptionFull.style.display = 'block';
    var descriptionShort = document.querySelector('.product-description-short');
    descriptionShort.style.display = 'none';
  });
  $('.readless').click(function(event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.product-description-full');
    descriptionFull.style.display = 'none';
    var descriptionShort = document.querySelector('.product-description-short');
    descriptionShort.style.display = 'block';
  });


  // Clerk popup
  document.addEventListener('product:added', function(event) {
    setTimeout(function() {
      var upsell = document.querySelector('#sidebar-cart');
      if (upsell) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      }
    }, 250);
  })


  /* Megamenu */
  var mainMenu = document.getElementById('sidebar-menu');
  if (mainMenu) {
    var menuToggles = mainMenu.querySelectorAll('.gr-menu-link[data-toggle-next]');
    var megaMenuCloses = mainMenu.querySelectorAll('[data-menu-back]');
    var megaMenuOpen = document.querySelectorAll('[data-mega-open]');
    var mainMenuOpen = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-menu"]')

    menuToggles.forEach(function(item) {
      item.addEventListener('click', function() {
        menuToggles.forEach(i => i.nextElementSibling.classList.remove('open'))

        item.nextElementSibling.classList.add('open');
        mainMenu.classList.add('menu-active');
      })
    })

    megaMenuCloses.forEach(function(button) {
      button.addEventListener('click', function() {
        menuToggles.forEach(i => i.nextElementSibling.classList.remove('open'))
        mainMenu.classList.remove('menu-active');
      })
    })

    megaMenuOpen.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        var megaToOpen = document.querySelector(`[data-mega="${ button.dataset.megaOpen }"]`);

        if (megaToOpen) {
          menuToggles.forEach(i => i.nextElementSibling.classList.remove('open'))
          megaToOpen.classList.add('open');
          mainMenuOpen.click();
          mainMenu.classList.add('menu-active');
        }
      })
    })
  }

  // Sidebar Menu - Accordions
  var menuItemExpanderToggles = document.querySelectorAll('[data-menu-item-expander-toggle]');

  menuItemExpanderToggles.forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var menuItemExpander = toggle.querySelector('[data-menu-item-expander]');
      var menuItemExpanderArrow = toggle.querySelector('[data-menu-item-arrow]');

      if (menuItemExpander) {
        menuItemExpander.classList.toggle('gr-expander--expanded');
        menuItemExpanderArrow.classList.toggle('gr-expander-arrow--active');
      }
    })
  })

});

const load = () => {
  function findAnchor() {
    if (window.location.hash.length > 1) {
      const searchElm = document.querySelector(`[data-id="${ window.location.hash.replace('#', '') }"]`);

      if (searchElm) {
        searchElm.scrollIntoView({
          block: 'center'
        })
      }
    }
  }

  window.addEventListener('hashchange', findAnchor);
  window.setTimeout(findAnchor, 1);
}

window.addEventListener('load', load);

/**
 * Product item swatches
 */

class ProductItemSwatch extends HTMLElement {

  constructor() {
    super();

    this.swatch = this.querySelector('.product-item-color-switch');
  }

  connectedCallback() {
    this.Init();
    this.AddEventListeners();
  }

  disconnectedCallback() {
    this.RemoveEventListeners();
  }

  Init() {

    // when document is ready
    if (document.readyState === 'complete') {
      if (this.swatch.checked) {
        this.SetQuickAddProduct();
      }
    }

  }

  AddEventListeners() {
    this.addEventListener('change', this.ChangeVariant.bind(this));
  }

  RemoveEventListeners() {
    this.removeEventListener('change', this.ChangeVariant.bind(this));
  }

  SetQuickAddProduct() {
    const swatch = this.swatch;
    const productItem = swatch.closest('.ProductItem');
    const goToVariant = productItem.querySelector('.go-to-variant');
    const quickAddProduct = productItem.querySelector('quick-add-product');
    const variantUrl = swatch.getAttribute('data-variant-url');
    const variantID = parseInt(swatch.getAttribute('data-variant-id'));

    if (quickAddProduct) {
      const quickAddProductButton = quickAddProduct.querySelector('button');
      const quickAddProductLink = quickAddProduct.querySelector('a');

      if (quickAddProduct && variantID) {
        quickAddProduct.setAttribute('data-variant-id', variantID);
        quickAddProductButton.removeAttribute('hidden', 'disabled');
        quickAddProductLink.setAttribute('hidden', 'disabled');
      }
      else {
        quickAddProductButton.setAttribute('hidden', 'disabled');
        quickAddProductLink.removeAttribute('hidden', 'disabled');
      }
    }

    if (goToVariant && variantUrl) {
      goToVariant.setAttribute('href', variantUrl);
    }
  }

  ChangeVariant() {
    const swatch = this.swatch;
    const productItem = swatch.closest('.ProductItem');
    const productPriceWrapper = productItem.querySelector('.ProductItem__PriceList');

    const price = swatch.getAttribute('data-price');
    const compareAtPrice = swatch.getAttribute('data-compare-at-price');
    const variantUrl = swatch.getAttribute('data-variant-url');
    const salePercentage = parseInt(swatch.getAttribute('data-sale-percentage'), 10);


    this.SetQuickAddProduct();


    if (!variantUrl) return;
    productItem.querySelector('.ProductItem__ImageWrapper').setAttribute('href', variantUrl);
    productItem.querySelector('.ProductItem__Title > a').setAttribute('href', variantUrl);

    // sale percentage
    if (productItem.querySelector('.ProductItem__Label')) {
      if (salePercentage === 0) {
        productItem.querySelector('.ProductItem__Label').classList.add('hide');
      } else {
        productItem.querySelector('.ProductItem__Label').innerHTML = '-' + salePercentage + '%';
        productItem.querySelector('.ProductItem__Label').classList.remove('hide');
      }
    }

    productPriceWrapper.innerHTML = `<span class="ProductItem__Price Price">${ languages.priceFrom } ${ slate.Currency.formatMoney(price, theme.moneyFormat) }</span>
${ compareAtPrice ? `<span class="ProductItem__Price Price Price--compareAt">${ slate.Currency.formatMoney(compareAtPrice, theme.moneyFormat) }</span>` : '' }
`

    // If we have a custom image for the variant, we change it
    const originalImageElement = productItem.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');

    if (swatch.hasAttribute('data-image-url') && swatch.getAttribute('data-image-id') !== originalImageElement.getAttribute('data-image-id')) {
      var newImageElement = document.createElement('img');
      newImageElement.className = 'ProductItem__Image Image--fadeIn Image--lazyLoad';
      newImageElement.setAttribute('data-image-id', swatch.getAttribute('data-image-id'));
      newImageElement.setAttribute('data-src', swatch.getAttribute('data-image-url'));
      newImageElement.setAttribute('data-widths', swatch.getAttribute('data-image-widths'));
      newImageElement.setAttribute('data-sizes', 'auto');

      // Replace the original node
      if (window.theme.productImageSize === 'natural') {
        originalImageElement.parentNode.style.paddingBottom = 100.0 / swatch.getAttribute('data-image-aspect-ratio') + '%';
      }

      originalImageElement.parentNode.style.setProperty('--aspect-ratio', swatch.getAttribute('data-image-aspect-ratio'));
      originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement);
    }
  }

}

customElements.define('product-item-swatch', ProductItemSwatch);



// Image Tabs
const imageTab = document.querySelector('[data-imagetabs]');

if (imageTab) {
  const imageTabListItem = imageTab.querySelectorAll('[data-imagetabs-tab]');
  const imageTabContent = imageTab.querySelectorAll('[data-imagetabs-content]');
  const imageTabImages = imageTab.querySelectorAll('[data-imagetabs-image]');
  imageTabListItem.forEach((item, index) => {
    item.addEventListener('click', () => {
      imageTabListItem.forEach(i => i.classList.remove('active'));
      item.classList.add('active');

      imageTabContent.forEach(i => i.classList.remove('active'));
      imageTabContent[index].classList.add('active');

      imageTabImages.forEach(i => i.classList.remove('active'));
      imageTabImages[index].classList.add('active');
    })
  })
}

/**
 * Predictive Search via. Shopify
 */

const openPredictiveSearch = document.querySelectorAll('[data-predictive-search-open]');
const closePredictiveSearch = document.querySelector('[data-predictive-search-close]');

const predictiveSearch = document.querySelector('[data-predictive-search]');

const predictiveSearchInput = document.querySelector('[data-predictive-search-input]');
const predictiveSearchInputClear = document.querySelector('[data-predictive-search-input-clear]');

const predictiveSearchResults = document.querySelector('[data-predictive-search-results]');
const predictiveSearchOverlay = document.querySelector('[data-predictive-search-overlay]');

const predictiveSearchSuggestions = document.querySelector('[data-predictive-search-suggestions]');

function debounce(func, delay) {
  let debounceTimer
  return function() {
    const context = this
    const args = arguments
    clearTimeout(debounceTimer)
    debounceTimer
      = setTimeout(() => func.apply(context, args), delay)
  }
}

if (predictiveSearch) {
  openPredictiveSearch.forEach(function(openBtn) {
    openBtn.addEventListener('click', function(event) {
      event.preventDefault()
      predictiveSearch.classList.add('predictive-search--active');
      predictiveSearchInput.focus();
      predictiveSearchOverlay.classList.add('predictive-search__overlay--active');
      document.body.style.overflow = "hidden";
    });
  });

  closePredictiveSearch.addEventListener('click', function() {
    predictiveSearch.classList.remove('predictive-search--active');
    predictiveSearchOverlay.classList.remove('predictive-search__overlay--active');
    document.body.style.overflow = "auto";
  });

  predictiveSearchOverlay.addEventListener('click', function() {
    predictiveSearch.classList.remove('predictive-search--active');
    predictiveSearchOverlay.classList.remove('predictive-search__overlay--active');
    document.body.style.overflow = "auto";
  });

  predictiveSearchInputClear.addEventListener('click', function() {
    predictiveSearchInput.value = '';
    predictiveSearchInputClear.classList.remove('searchClearQuery--active');
    predictiveSearchResults.classList.remove('predictive-search__body--active');
    predictiveSearchSuggestions.classList.remove('predictive-search__body--active');
    predictiveSearchResults.innerHTML = predictiveSearchSuggestions.innerHTML;
  });

  predictiveSearchInput.addEventListener('keydown', debounce(() => {
    if (predictiveSearchInput.value.length > 0) {
      predictiveSearchInputClear.classList.add('searchClearQuery--active');

      fetch(`/search/suggest?q=${ predictiveSearchInput.value }&resources[type]=product,collection,article&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }

          return response.text();
        })
        .then(async (text) => {
          const textDOM = new DOMParser().parseFromString(text, 'text/html');
          const resultsWrapper = textDOM.querySelector('[data-predictive-search-results]');

          if (resultsWrapper) {
            predictiveSearchResults.innerHTML = resultsWrapper.innerHTML;
            predictiveSearchResults.classList.add('predictive-search__body--active');

            const predictiveSearchViewAll = document.querySelector('[data-predictive-search-submit-view-all]');
            if (predictiveSearchViewAll) {
              predictiveSearchViewAll.addEventListener('click', function(event) {
                event.preventDefault();
                predictiveSearchInput.form.submit();
              });
            }

            // renderSwatchListener();
          }
        })
        .catch((error) => {
          throw error;
        });
    } else {
      predictiveSearchInputClear.classList.remove('searchClearQuery--active');
      predictiveSearchResults.innerHTML = predictiveSearchSuggestions.innerHTML;
    }
  }, 250));
}

/**
 * Search Results Page
 */

let searchLoadMore = document.querySelector('[data-search-load-more]');
let searchResults = document.querySelector('[data-search-results]');
let searchPagination = document.querySelector('[data-search-pagination]');
const searchURL = new URL(window.location.href);

function loadNextPage() {
  const currentPage = parseInt(searchLoadMore.dataset.searchCurrentPage, 10);
  fetch(`${ searchURL.pathname }?page=${ currentPage + 1 }&q=${ searchURL.searchParams.get('q') }&type=product`)
    .then((response) => {
      if (!response.ok) {
        throw new Error(response.status);
      }

      return response.text();
    })
    .then(async (text) => {
      const textDOM = new DOMParser().parseFromString(text, 'text/html');
      const resultsWrapper = textDOM.querySelector('[data-search-results]');
      const paginationWrapper = textDOM.querySelector('[data-search-pagination]');
      const loadMoreWrapper = textDOM.querySelector('[data-search-load-more]');

      if (resultsWrapper) {
        searchResults.innerHTML += resultsWrapper.innerHTML;
        searchPagination.innerHTML = paginationWrapper.innerHTML;
        searchLoadMore.outerHTML = loadMoreWrapper.outerHTML;
        // renderSwatchListener();
        document.dispatchEvent(new CustomEvent('search:nextpage'));
      }
    })
    .catch((error) => {
      throw error;
    });
}

if (searchLoadMore) {
  searchLoadMore.addEventListener('click', function(event) {
    event.preventDefault();
    loadNextPage();
  });
}

document.addEventListener('search:nextpage', function() {
  searchPagination = document.querySelector('[data-search-pagination]');
  searchLoadMore = document.querySelector('[data-search-load-more]');
  searchResults = document.querySelector('[data-search-results]');

  if (searchLoadMore) {
    searchLoadMore.addEventListener('click', function(event) {
      event.preventDefault();
      loadNextPage();
    });
  }
});

/**
 * Product Recommendations (sections/blocks) via. Shopify
 */

const productRecommendations = document.querySelectorAll('[data-product-recommendations]');
if (productRecommendations) {
  productRecommendations.forEach((productRecommendation) => {
    const productRecommendationURL = productRecommendation.dataset.url;
    fetch(productRecommendationURL)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        return response.text();
      })
      .then(async (text) => {
        const textDOM = new DOMParser().parseFromString(text, 'text/html');
        const recommendationsWrapper = textDOM.querySelector('[data-product-recommendations]');

        if (recommendationsWrapper) {
          productRecommendation.innerHTML = recommendationsWrapper.innerHTML;

          const recommendationsSlider = productRecommendation.querySelector('[data-product-recommendations-slider]');
          const flickityOptions = JSON.parse(productRecommendation.dataset.flickityConfig);
          if (!recommendationsSlider) return
          new Flickity(recommendationsSlider, flickityOptions);
          // renderSwatchListener();
        }
      })
      .catch((error) => {
        throw error;
      });
  });
}

/**
 * Product Recommendations (PDP) via. Shopify
 */

const productRecommendationsOthersBought = document.querySelector('[data-product-recommendations-others-bought]');

if (productRecommendationsOthersBought) {
  const productRecommendationsOthersBoughtURL = productRecommendationsOthersBought.dataset.url;
  fetch(productRecommendationsOthersBoughtURL)
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      return response.text();
    })
    .then(async (text) => {
      const textDOM = new DOMParser().parseFromString(text, 'text/html');
      const recommendationsWrapper = textDOM.querySelector('[data-product-recommendations-others-bought]');

      if (recommendationsWrapper) {
        productRecommendationsOthersBought.innerHTML = recommendationsWrapper.innerHTML;

        const recommendationsSlider = productRecommendationsOthersBought.querySelector('[data-product-recommendations-slider-others-bought]');
        const flickityOptions = JSON.parse(productRecommendationsOthersBought.dataset.flickityConfig);
        new Flickity(recommendationsSlider, flickityOptions);
        // renderSwatchListener();
      }
    })
    .catch((error) => {
      throw error;
    });
}

/**
 * Cart Recommendations via. Shopify
 */


const setSliderHeight = (slider) => {
  setTimeout(() => {
    slider.cells.forEach(cell => cell.element.style.height = '');

    let heights = slider.cells.map(cell => cell.element.offsetHeight),
      max = Math.max.apply(Math, heights);

    slider.cells.forEach(cell => cell.element.style.height = max + 'px');

    slider.viewport.style.height = max + 'px';
  }, 0);
}


const globalCartRecommendations = document.querySelector('[data-global-cart-recommendations]');

if (globalCartRecommendations) {
  const globalCartRecommendationsURL = globalCartRecommendations.dataset.url;
  const sectionId = globalCartRecommendations.dataset.sectionId;
  document.addEventListener('product:added', async () => {
    const fetchShopifySection = async (sectionId) => {
      const url = window.Shopify.routes.root + globalCartRecommendationsURL;


      console.log(`url: `, url);
      try {
        const response = await fetch(url);
        const data = await response.text();
        const dom = new DOMParser().parseFromString(data, 'text/html');
        const section = dom.querySelector(`[data-section-id="${ sectionId }"]`);
        return section;
      } catch (error) {
        console.error('Error fetching Shopify section:', error);
      }
    };

    const sectionHTML = await fetchShopifySection(sectionId);

    if (sectionHTML) {

      globalCartRecommendations.innerHTML = sectionHTML.innerHTML;

    }

    const recommendationsSlider = globalCartRecommendations.querySelector('[data-cart-recommendations-slider]');

      if (!recommendationsSlider.querySelector('.flickity-slider')) {

        const flickityOptions = JSON.parse(globalCartRecommendations.dataset.flickityConfig);
        const upsellSlider = new Flickity(recommendationsSlider, flickityOptions);

        upsellSlider.on('resize', () => {
          setSliderHeight(upsellSlider);
        });

        upsellSlider.on('change', () => {
          setSliderHeight(upsellSlider);
        });

        setSliderHeight(upsellSlider);

      } else {
        recommendationsSlider.querySelector('.flickity-slider').innerHTML = '';

        recommendationsPlaceholder.flat().forEach((item) => {
          if (recommendationsPlaceholder.indexOf(item) < 8) {
            recommendationsSlider.querySelector('.flickity-slider').appendChild(item);
          }
        })

        Flickity.data(recommendationsSlider).reloadCells();
        Flickity.data(recommendationsSlider).select(0);

        setSliderHeight(Flickity.data(recommendationsSlider));

      }

  });
}


const cartRecommendations = document.querySelector('[data-cart-recommendations]');

if (cartRecommendations) {
  const cartRecommendationsURL = cartRecommendations.dataset.url;
  const getCart = async () => {
    return fetch(window.routes.cartUrl + '.js').then(response => response.json())
  }

  document.addEventListener('product:added', () => {
    getCart().then(async (cart) => {
      if (cart.item_count > 0) {
        const { items } = cart;
        const fetches = [];

        items.forEach((item) => {
          const productId = item.product_id;

          fetches.push(fetch(cartRecommendationsURL + '&product_id=' + productId)
            .then((response) => response.text()
            ));
        });

        const recommendationsPlaceholder = [];

        await Promise.all(fetches).then((data) => {
          data.map((item => {
            const textDOM = new DOMParser().parseFromString(item, 'text/html');
            const recommendationsWrapper = textDOM.querySelector('[data-cart-recommendations-slider]').children;

            [...recommendationsWrapper].forEach((child) => {
              if (![...recommendationsPlaceholder].map((elem) => elem.dataset.handle).includes(child.dataset.handle)) {
                recommendationsPlaceholder.push(child);
              }
            });
          }))
        });

        const recommendationsSlider = cartRecommendations.querySelector('[data-cart-recommendations-slider]');

        if (!recommendationsSlider.querySelector('.flickity-slider')) {
          recommendationsPlaceholder.flat().forEach((item) => {
            if (recommendationsPlaceholder.indexOf(item) < 8) {
              recommendationsSlider.appendChild(item);
            }
          })


          const flickityOptions = JSON.parse(cartRecommendations.dataset.flickityConfig);
          const upsellSlider = new Flickity(recommendationsSlider, flickityOptions);

          upsellSlider.on('resize', () => {
            setSliderHeight(upsellSlider);
          });

          upsellSlider.on('change', () => {
            setSliderHeight(upsellSlider);
          });

          setSliderHeight(upsellSlider);

        } else {
          recommendationsSlider.querySelector('.flickity-slider').innerHTML = '';

          recommendationsPlaceholder.flat().forEach((item) => {
            if (recommendationsPlaceholder.indexOf(item) < 8) {
              recommendationsSlider.querySelector('.flickity-slider').appendChild(item);
            }
          })

          Flickity.data(recommendationsSlider).reloadCells();
          Flickity.data(recommendationsSlider).select(0);

          setSliderHeight(Flickity.data(recommendationsSlider));

        }
      }
    })
  })
}


class QuickAddProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Add any code that needs to run when the element is added to the DOM
    this.Init();
    this.AddEventListeners();
  }

  disconnectedCallback() {
    // Add any cleanup logic here
    this.RemoveEventListeners();
  }

  Init() {
    this.dom = {};
    this.dom.addToCartButton = this.querySelector('button[data-action="add-to-cart"]');
    this.dom.addToCartText = this.querySelector('.add-to-cart-text');
  }

  AddEventListeners() {
    // Add any event listeners you'll need for your element here
    this.dom.addToCartButton.addEventListener('click', this.AddToCart.bind(this));
  }

  RemoveEventListeners() {
    // Remove any event listeners you added in connectedCallback() here
    this.dom.addToCartButton.removeEventListener('click', this.AddToCart.bind(this));
  }

  AddToCart() {
    const variantId = this.dataset.variantId;
    const quantity = 1;

    this.dom.addToCartButton.setAttribute('disabled', 'disabled');
    this.dom.addToCartText.innerText = window.languages.productAdding;

    fetch(window.routes.cartAddUrl + '.js', {
      body: JSON.stringify({ id: variantId, quantity: quantity }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then((response) => {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      if (response.ok) {
        // We simply trigger an event so the mini-cart can re-render
        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: variantId,
            quantity: quantity
          }
        }));

        this.dom.addToCartText.innerText = window.languages.productAdded;
        this.dom.addToCartButton.removeAttribute('disabled');

        setTimeout(() => {
          this.dom.addToCartText.innerText = window.languages.productAddShort;
        }, 300);

      } else {
        this.dom.addToCartText.innerText = window.languages.productAddShort;
        response.json().then((content) => {
          var errorMessageElement = document.createElement('span');
          errorMessageElement.className = 'ProductForm__Error Alert Alert--error quick-add-error';
          errorMessageElement.innerHTML = content['description'];

          this.dom.addToCartButton.removeAttribute('disabled');
          this.dom.addToCartButton.insertAdjacentElement('beforebegin', errorMessageElement);
          setTimeout(function() {
            errorMessageElement.remove();
          }, 4000);
        });
      }
    });
  }
}

customElements.define('quick-add-product', QuickAddProduct);


class ProductSku extends HTMLElement {
  constructor() {
    super();
    this.sku = this.querySelector('span');
    if (!this.sku) return;
  }

  connectedCallback() {
    // Add any code that needs to run when the element is added to the DOM
    this.AddEventListeners();
  }

  disconnectedCallback() {
    // Add any cleanup logic here
    this.RemoveEventListeners();
  }



  AddEventListeners() {
    // Add any event listeners you'll need for your element here
    document.addEventListener('variant:changed', this.ChangeSku.bind(this));
  }

  RemoveEventListeners() {
    // Remove any event listeners you added in connectedCallback() here
    document.removeEventListener('variant:changed', this.ChangeSku.bind(this));
  }

  ChangeSku(event) {
    const sku = event.detail.variant.sku;
    if (sku) {
      this.removeAttribute('hidden');
      this.sku.innerHTML = sku;
    }
    else {
      this.setAttribute('hidden', '');
    }
  }
}

customElements.define('product-sku', ProductSku);


class ProductPageNavElement extends HTMLElement {
  constructor() {
    super();
    this.dom = {};
    this.dom.linkElement = this.querySelector('a');
    this.dom.parent = this.closest('li');
  }

  connectedCallback() {
    // when dom is ready
    document.addEventListener("DOMContentLoaded", this.Init.bind(this));
  }

  disconnectedCallback() {
    // Add any cleanup logic here
    document.removeEventListener("DOMContentLoaded", this.Init.bind(this));

  }

  Init() {
    const elementId = this.dom.linkElement.getAttribute('href').replace('#', '');
    const linkElement = document.getElementById(elementId);
    if (!linkElement) this.dom.parent.remove();
    this.dom.parent.removeAttribute('hidden');
  }
}

customElements.define('pdp-nav-elem', ProductPageNavElement);


class ProductPageNavigation extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.Init();
  }

  disconnectedCallback() {
    this.RemoveEventListeners();
  }

  Init() {
    this.SetHeight();
    this.AddEventListeners();
  }

  Debounce(func, delay) {
    let timeoutId;

    return function() {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(func, delay);
    };
  }

  AddEventListeners() {
    window.addEventListener('resize', this.Debounce(this.SetHeight.bind(this), 200));
  }

  RemoveEventListeners() {
    window.removeEventListener('resize', this.Debounce(this.SetHeight.bind(this), 200));
  }

  SetHeight() {
    const navHeight = this.offsetHeight;
    document.documentElement.style.setProperty('--pdp-nav', navHeight + 'px');
  }
}
customElements.define('pdp-nav', ProductPageNavigation);

const videoTiles = document.querySelectorAll('[data-autoplay-on-mouseover]');
if (videoTiles) {
  videoTiles.forEach(videoTile => {
    videoTile.addEventListener('mouseover', () => {
      if (!videoTile.src) {
        videoTile.src = videoTile.dataset.src;
      }

      if (videoTile.paused) {
        videoTile.play();
      }
    })

    // videoTile.addEventListener('mouseout', () => {
    //   videoTile.pause();
    // })
  })
}

const videoTilesClickToPlay = document.querySelectorAll('[data-play-on-click]');
if (videoTilesClickToPlay) {
  videoTilesClickToPlay.forEach(videoTile => {
    videoTile.addEventListener('click', () => {
      if (!videoTile.src) {
        videoTile.src = videoTile.dataset.src;
        videoTile.setAttribute('controls', '');
        videoTile.play();
      }
    })
  })
}


/*
* Cart bundle
*/

document.addEventListener('cart:page:rendered', async () => {
  const bundleItems = document.querySelectorAll('[data-bundle]');

  if (!bundleItems) {
    return;
  }

  let cart = await fetch(window.routes.cartUrl + '.js').then(response => response.json());

  const renderCart = () => {
    fetch(window.routes.cartUrl + '?view=ajax&timestamp=' + Date.now(), {
      credentials: 'same-origin',
      method: 'GET'
    }).then(function(content) {
        content.text().then(function (html) {
          const tempElement = document.createElement('div');
          tempElement.innerHTML = html;

          const cartNodeParent = document.querySelector('.Cart').parentNode;
          cartNodeParent.replaceChild(tempElement.querySelector('.Cart'), document.querySelector('.gr-cart__right').parentNode);

          document.dispatchEvent(new Event('cart:page:rendered'));
        });
    });
  }

  bundleItems.forEach(bundleItem => {
    const bundleId = bundleItem.dataset.bundle;
    const deleteBtn = bundleItem.querySelector('[data-remove-bundle]');

    deleteBtn.addEventListener('click', (event) => {
      event.preventDefault();

      const itemsToBeRemoved = cart.items.filter(item => item.properties['_planner_code'] == bundleId);
      const updates = {};

      itemsToBeRemoved.forEach(item => {
        updates[item.key] = 0;
      });

      const attributeKey = Object.keys(cart.attributes).filter(key => key.includes(bundleId));
      const attributes = {
        [attributeKey]: ''
      }

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({updates, attributes})
      }).then(() => {
        renderCart();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    });
  });
});

/*
* Search Manuals
*/

document.addEventListener('DOMContentLoaded', () => {
  const searchInput = document.getElementById('search-manuals');
  const resultsList = document.querySelector('.results-list');
  const videoOverlay = document.querySelector('[data-video-overlay]');

  if (!searchInput || !resultsList || !videoOverlay) {
    return;
  }

  const convertToEmbed = (link) => {
    const pattern = /(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/(watch\?v=|embed\/|v\/|shorts\/|.+\?v=)?([^&=%\?]{11})/;
    const match = link.match(pattern);

    if (match) {
      const videoId = match[5];
      const embedLink = `https://www.youtube.com/embed/${videoId}`;
      return embedLink;
    } else {
      return "Invalid YouTube URL";
    }
  }

  const toggleOverlay = (videoSrc) => {
    videoOverlay.querySelector('iframe').src = videoSrc ? convertToEmbed(videoSrc) : '';
    document.body.classList.toggle('overflow-hidden');
    videoOverlay.classList.toggle('video-overlay--active');
  }

  videoOverlay.addEventListener('click', () => toggleOverlay(''));

  const addButtonEventListeners = () => {
    const videoBtns = resultsList.querySelectorAll('[data-video]');
    videoBtns.forEach(videoBtn => videoBtn.addEventListener('click', () => toggleOverlay(videoBtn.dataset.video)));
  }

  const debounce = (callback, wait) => {
    let timeoutId = null;
    return (...args) => {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => {
        callback(...args);
      }, wait);
    };
  }

  const searchManuals = debounce((searchTerm) => {
    const url = searchTerm
      ? `search/suggest?q=${searchTerm}&resources[type]=product&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.title,variants.sku&section_id=search-manuals`
      : "?sections=search-manuals"

    fetch(window.Shopify.routes.root + url)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }

      if (searchTerm) {
        return response.text();
      }

      return response.json();
    })
    .then((text) => {
      if (typeof text === 'object' && !Array.isArray(text) && text !== null) {
        text = Object.values(text)[0];
      }

      const resultsMarkup = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('.results-list').innerHTML;

      resultsList.innerHTML = resultsMarkup;

      addButtonEventListeners();
    })
    .catch((error) => {
      throw error;
    });
  }, 300);

  addButtonEventListeners();
  searchInput.addEventListener('input', (event) => searchManuals(event.target.value));
});
